import React, { FC } from 'react';
import styles from './ItemTitles.module.scss';

export const ItemTitles: FC<{
  headlineTitle?: string;
  secondaryTitle?: string;
}> = ({ headlineTitle, secondaryTitle }) => {
  return (
    <>
      {secondaryTitle && (
        <p className={styles.secondaryTitle} aria-label={secondaryTitle}>
          {secondaryTitle}
        </p>
      )}
      <p className={styles.headlineTitlePadding} aria-label={headlineTitle}>
        {headlineTitle}
      </p>
    </>
  );
};
